// extracted by mini-css-extract-plugin
module.exports = {"toggler":"ProductsMobile_toggler__VjRAX"};